import { Theme } from "@material-ui/core";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => ({
  activatedCoach: {},
  completedCheck: {
    color: "green",
  },
  deactivatedCoach: {
    backgroundColor: `rgba(${hexToRGB(theme.palette.error.main)}, 0.075)`,
  },
  noResponses: {
    color: "grey",
  },
  studentCount: {
    minWidth: 20,
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/components/coach-row/styles.ts